//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import list from './dataList.json';
export default {
  name: 'resbdguideroomnumber',
  data(){
     return{
        buildHeadBeans:{
            UnitBean:[]
        },
       floorBeanLists:[]
     } 
  },
  mounted(){
   
  },
  computed:{
  
  },
  watch:{
      floorBeanList:{
       handler:function(newval,oldval){
            this.floorBeanLists=this.cloneDeepJson(this.floorBeanList)
       },
       deep: true
     },
     buildHeadBean:{
       handler:function(newval,oldval){
            this.buildHeadBeans=this.cloneDeepJson(this.buildHeadBean)
       },
       deep: true
     },
     roomBean:{
       handler:function(newval,oldval){
            this.changeRomm()
       },
       deep: true
     },

  },
  props: {
    buildHeadBean:Object,
    floorBeanList:Array,
    model: Object,
    getLangMsg: Function,
    invoke: Function,
    roomBean:Object
  },
   created() {
    this.handleToNextStep()
  },
  methods:{
     cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
      },
     changeRomm(){
         this.floorBeanLists.forEach(i=>{
            i.unitBeanList.forEach(ii=>{
               ii.roomBeanList.forEach(iii=>{
                   if(iii.id==this.roomBean.id){
                      iii.roomNumber=this.roomBean.roomNumber
                   }
               })
            })
         })
     },
     roomClick(e,id){
          console.log(e.target.value,id,'e')

      //  if(e.target.value){
           let value={
            roomId:id,
            roomNumber:e.target.value
         }
         let parm={content:{ type:'guideroomnumber_set_roomnumber', value:value}}
         console.log('传给后台的参数',parm)
         this.invoke('invokeCustomEvent',parm) 
     },
     handleToNextStep: function () {
      console.log('init_data')
      this.invoke('invokeCustomEvent',{content:{ type: 'guideroomnumber_init_roomnumberdata', value:''}})
    },
  
  }
}
